const SAVE_POSTING_DB = 'publicador-profesionales/savePosting/SAVE_POSTING_DB';
const SAVE_POSTING_DB_COMPLETED = 'publicador-profesionales/savePosting/SAVE_POSTING_DB_COMPLETED';
const SAVE_POSTING_DB_FAILED = 'publicador-profesionales/savePosting/SAVE_POSTING_DB_FAILED';
const SAVE_POSTING_DB_CLEAR = 'publicador-profesionales/savePosting/SAVE_POSTING_DB_CLEAR';
const SAVE_POSTING_SET_SAVE_SOURCE = 'publicador-profesionales/savePosting/SAVE_POSTING_SET_SAVE_SOURCE';
const SET_LOADING = 'publicador-profesionales/savePosting/SET_LOADING';
const SAVE_POSTING_DB_WITHOUT_CHANGES = 'publicador-profesionales/savePosting/SAVE_POSTING_DB_WITHOUT_CHANGES';

export {
  SAVE_POSTING_DB,
  SAVE_POSTING_DB_COMPLETED,
  SAVE_POSTING_DB_FAILED,
  SAVE_POSTING_SET_SAVE_SOURCE,
  SAVE_POSTING_DB_CLEAR,
  SET_LOADING,
  SAVE_POSTING_DB_WITHOUT_CHANGES
};
